(function (upp) {
    'use strict';
    upp.service('location', ['$location', '$window', '$rootScope', 'device',
        function ($location, $window, $rootScope, device) {

            /**
             * Change the url of the webapp
             *
             * @method path
             * @param {String} url
             * @param {Boolean} applyDigest if explicitly want to make $rootScope.apply() to refresh the url
             */
            var path = function (url, applyDigest) {
                if (url) {
                    $location.path(url);
                    if (applyDigest) {
                        $rootScope.$apply();
                    }
                } else {
                    throw new Error("Not url to open");
                }
            };


            /**
             * Open external url
             *
             * @method open
             * @param {String} url
             */
            var open = function (url) {
                if (url) {
                    $window.location.href = url;
                } else {
                    throw new Error("Not url to open");
                }
            };

            /**
             * Open external url and, in phonegap, listen to changes in the url to apply functions
             *
             * @method open
             * @param {String} url
             * @param {String} content (for phonegap open)
             * @param {Function} callback to listen events
             * @param {boolean} force, if we want to force open in new window.
             * @return {window} the window opened
             */
            var openWindowInPhonegap = function (url, content, callback, force) {
                if (url) {
                    if (device.inPhonegap()) {
                        var _window = window;

                        var ref = _window.open(content, '_blank', 'location=no');
                        var inAppBrowserUrlLoadStart = function (inAppBrowser) {
                            return callback(ref, inAppBrowser);
                        };
                        var inAppBrowserClosed = function (inAppBrowser) {
                            return function () {
                                inAppBrowser.removeEventListener('loadstart', inAppBrowserUrlLoadStart);
                                inAppBrowser.removeEventListener('exit', inAppBrowserClosed);
                            }
                        };
                        ref.addEventListener('loadstart', inAppBrowserUrlLoadStart);
                        ref.addEventListener('exit', inAppBrowserClosed);
                    }
                    else if (force) {
                        // web based popup
                        var _window = window;
                        var ref = _window.open(url, '_blank', 'location=no');

                        var _url = url;

                        var timer = setInterval(function() {

                            var unknown = 'unknown';
                            var currentUrl = unknown;

                            try {
                                currentUrl = ref.location.href || unknown;
                            } catch(e) {
                                console.log(e);
                            }

                            if (ref.closed) {
                                clearInterval(timer);
                                _url = currentUrl;
                                if (_url === unknown) {
                                    // if we are in unknown domain, we cant access to the window (ref) object so we set to undefined
                                    ref = undefined;
                                }
                                callback(ref, { url: _url, closed: true });
                            } else {
                                if (currentUrl.indexOf(_url) < 0) {
                                    // url changed
                                    _url = currentUrl;
                                    // only do the callback with known domain, otherwise we wait to the user to close the modal.
                                    if (_url !== unknown) {
                                        callback(ref, { url: _url, closed: false });
                                    }
                                }
                            }

                        }, 500);
                    }
                    else {
                        open(url);
                    }
                } else {
                    throw new Error("Not url to open");
                }
            };

            return {
                path:path,
                open:open,
                openWindowInPhonegap:openWindowInPhonegap
            }
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/common/services/location-service.js